export function getListItemCount() {
  const { clientHeight } = document.documentElement;
  const drawerHeaderHeight = 56;
  const paginationHeight = 56;
  const listItemHeight = 64;
  return Math.trunc(
    (clientHeight - drawerHeaderHeight - paginationHeight) / listItemHeight,
  );
}
